// // 1st version

// // import React from 'react';
// // import { Bar } from 'react-chartjs-2';
// // import { ChartOptions } from 'chart.js';
// // import {
// //   Chart as ChartJS,
// //   CategoryScale,
// //   LinearScale,
// //   BarElement,
// //   Tooltip,
// //   Legend,
// // } from 'chart.js';

// // ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// // interface BarChartProps {
// //   title: string;
// //   data: { name: string; value: number; hours?: string }[];
// //   colors: { barColor: string; labelColor?: string };
// //   totalEmployees?: number;
// //   totalActiveHours?: number;
// //   idlePercentage?: number;
// //   direction?: 'vertical' | 'horizontal';
// //   barThickness?: number | string; // Accept both number and percentage
// //   chartWidth: string;
// //   totalPercentage?: number;
// // }

// // export const BarChart: React.FC<BarChartProps> = ({
// //   title,
// //   data,
// //   colors,
// //   totalEmployees,
// //   totalActiveHours,
// //   // idlePercentage,
// //   direction = 'vertical',
// //   barThickness = 10,
// //   chartWidth,
// //   totalPercentage,
// // }) => {
// //   // Helper function to extract domain name from URL
// //   const getDomainName = (url: string): string => {
// //     try {
// //       const hostname = new URL(url).hostname;
// //       // Remove "www." if it exists
// //       const domain = hostname.startsWith('https//') ? hostname.slice(4) : hostname.slice(0,5);
// //       return domain.split('.')[0]; // Return only the main domain
// //     } catch {
// //       return url.slice(0,8); // Fallback if it's not a valid URL
// //     }
// //   };

// //   const labels = data.map((item) => `${getDomainName(item.name)}..`);
// //   const fullUrls = data.map((item) => item.name);
// //   const values = data.map((item) => item.value);
// //   const hours = data.map((item) => item.hours);

// //   const baseColor = colors.barColor;
// //   const barColors = values.map((_, index) => {
// //     // const opacity = 1 - index * 0.12;
// //     const opacity = 1 - index * 0.009;
// //     return `${baseColor}${Math.round(opacity * 255).toString(16).padStart(2, '0')}`;
// //   });
// //   const chartData = {
// //     labels,
// //     datasets: [
// //       {
// //         data: values,
// //         backgroundColor: barColors,
// //         borderRadius: 4,
// //         borderSkipped: false,
// //         borderWidth: 0,
// //         barThickness: typeof barThickness === 'number' ? barThickness : undefined,
// //         barPercentage:
// //           typeof barThickness === 'string'
// //             ? parseFloat(barThickness) / 100
// //             : 0.7,
// //         categoryPercentage: 0.8,
// //       },
// //     ],
// //   };

// //   const options: ChartOptions<'bar'> = {
// //     indexAxis: direction === 'horizontal' ? 'y' : 'x',
// //     responsive: true,
// //     maintainAspectRatio: false,
// //     plugins: {
// //       tooltip: {
// //         callbacks: {
// //           title: (tooltipItems) => {
// //             const index = tooltipItems[0]?.dataIndex || 0;
// //             return fullUrls[index];
// //           },
// //           label: (context: any) => `${hours[context.dataIndex]}`,
// //         },
// //       },
// //       legend: {
// //         display: false,
// //       },
// //     },
// //     scales: {
// //       x: {
// //         display: true,
// //         grid: {
// //           display: false,
// //         },
// //         ticks: {
// //           callback: (value: any, index: number) => labels[index],
// //           color: colors.labelColor,
// //         },
// //       },
// //       y: {
// //         ticks: {
// //           align: 'start',
// //           padding: 10,
// //           color: colors.labelColor,
// //           font: {
// //             size: 12,
// //           },
// //         },
// //         grid: {
// //           display: false,
// //         },
// //         border: {
// //           display: false,
// //         },
// //       },
// //     },
// //   };
// //   return (
// //     <div className="rounded-lg pt-[28px] mb-6 w-full">
// //       <h3 className="text-sm leading-[20px] text-start font-semibold text-[#000000] mb-2">{title}</h3>
// //       <div className="flex gap-[27px] justify-start text-xs text-[#000000] mb-4">
// //         {
// //           totalEmployees && <span>Total Active Employee: {totalEmployees}</span>
// //         }
// //         {
// //           totalActiveHours && <span>Total Active Hours: {totalActiveHours}</span>
// //         }
// //         {
// //           totalPercentage && <span>Total Activity Percentage: {totalPercentage}%</span>
// //         }
// //       </div>
// //       <div
// //         className={`relative flex h-64 text-xs leading-normal text-[#000]`}
// //         style={{ width: chartWidth }}
// //       >
// //         <Bar data={chartData} options={options} />
// //       </div>
// //     </div>
// //   );
// // };

// // 2nd version

// // import React from 'react';
// // import { Bar } from 'react-chartjs-2';
// // import { ChartOptions } from 'chart.js';
// // import {
// //   Chart as ChartJS,
// //   CategoryScale,
// //   LinearScale,
// //   BarElement,
// //   Tooltip,
// //   Legend,
// // } from 'chart.js';

// // ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// // interface BarChartProps {
// //   title?: string;
// //   data: { name: string; value: number; hours?: string }[];

// //   barColor: string;         // ✅ individual
// //   hoverColor?: string;      // ✅ individual
// //   labelColor?: string;      // ✅ individual

// //   totalEmployees?: number;
// //   totalActiveHours?: number;
// //   idlePercentage?: number;
// //   direction?: 'vertical' | 'horizontal';
// //   barThickness?: number | string;
// //   chartWidth: string;
// //   totalPercentage?: number;
// //   barToBarSpace?: number | string;
// // }

// // export const BarChart: React.FC<BarChartProps> = ({
// //   title,
// //   data,
// //   barColor,
// //   hoverColor,
// //   labelColor,
// //   totalEmployees,
// //   totalActiveHours,
// //   direction = 'vertical',
// //   barThickness = 10,
// //   chartWidth,
// //   totalPercentage,
// //   barToBarSpace,
// // }) => {
// //   const getDomainName = (url: string): string => {
// //     try {
// //       const hostname = new URL(url).hostname;
// //       return hostname.replace(/^www\./, '').split('.')[0];
// //     } catch {
// //       return url.slice(0, 8);
// //     }
// //   };

// //   const labels = data.map((item) => `${getDomainName(item.name)}..`);
// //   const fullUrls = data.map((item) => item.name);
// //   const values = data.map((item) => item.value);
// //   const hours = data.map((item) => item.hours);

// //   const baseColor = barColor;
// //   const hoverBase = hoverColor || barColor;

// //   const barColors = values.map((_, index) => {
// //     const opacity = 1 - index * 0.009;
// //     return `${baseColor}${Math.round(opacity * 255).toString(16).padStart(2, '0')}`;
// //   });

// //   const hoverColors = values.map((_, index) => {
// //     const opacity = 1 - index * 0.009;
// //     return `${hoverBase}${Math.round(opacity * 255).toString(16).padStart(2, '0')}`;
// //   });

// //   const isBarPercent =
// //     typeof barThickness === 'string' && barThickness.trim().endsWith('%');
// //   const parsedBarPercentage = isBarPercent
// //     ? parseFloat(barThickness as string) / 100
// //     : undefined;

// //   let categoryPercentage = 0.8;
// //   if (typeof barToBarSpace === 'string' && barToBarSpace.endsWith('%')) {
// //     const percent = parseFloat(barToBarSpace);
// //     categoryPercentage = 1 - percent / 100;
// //   } else if (typeof barToBarSpace === 'number') {
// //     const spacingFactor = Math.min(Math.max(barToBarSpace / 10, 0), 0.9);
// //     categoryPercentage = 1 - spacingFactor;
// //   }

// //   const chartData = {
// //     labels,
// //     datasets: [
// //       {
// //         data: values,
// //         backgroundColor: barColors,
// //         hoverBackgroundColor: hoverColors,
// //         borderRadius: 4,
// //         borderSkipped: false,
// //         borderWidth: 0,
// //         ...(typeof barThickness === 'number'
// //           ? { barThickness, barPercentage: 1 }
// //           : {
// //               barThickness: undefined,
// //               barPercentage: parsedBarPercentage || 0.7,
// //             }),
// //         categoryPercentage,
// //       },
// //     ],
// //   };

// //   const options: ChartOptions<'bar'> = {
// //     indexAxis: direction === 'horizontal' ? 'y' : 'x',
// //     responsive: true,
// //     maintainAspectRatio: false,
// //     plugins: {
// //       tooltip: {
// //         callbacks: {
// //           title: (tooltipItems) => {
// //             const index = tooltipItems[0]?.dataIndex || 0;
// //             return fullUrls[index];
// //           },
// //           label: (context: any) => `${hours[context.dataIndex]}`,
// //         },
// //       },
// //       legend: { display: false },
// //     },
// //     scales: {
// //       x: {
// //         display: true,
// //         grid: { display: false },
// //         ticks: {
// //           callback: (value: any, index: number) => labels[index],
// //           color: labelColor,
// //         },
// //       },
// //       y: {
// //         beginAtZero: true,
// //         suggestedMin: 0,
// //         suggestedMax: 100,
// //         ticks: {
// //           align: 'start',
// //           padding: 10,
// //           color: labelColor,
// //           font: { size: 12 },
// //           stepSize: 20,
// //           callback: (value) => `${value}`,
// //           maxTicksLimit: 8,
// //         },
// //         grid: { display: false },
// //         border: { display: false },
// //       },
// //     },
// //   };

// //   return (
// //     <div className="rounded-lg pt-[28px] mb-6 w-full">
// //       <h3 className="text-sm leading-[20px] text-start font-semibold text-[#000000] mb-2">
// //         {title}
// //       </h3>
// //       <div
// //         className="relative flex items-center justify-center h-64 text-xs leading-normal text-[#000] "
// //         style={{ width: chartWidth }}
// //       >
// //         {data?.length > 0 ? (
// //           <Bar data={chartData} options={options} />
// //         ) : (
// //           <div className="flex flex-col items-center justify-center text-center px-4 py-6 text-sm text-gray-500">
// //             <svg
// //               xmlns="http://www.w3.org/2000/svg"
// //               className="w-8 h-8 mb-2 text-gray-400"
// //               fill="none"
// //               viewBox="0 0 24 24"
// //               stroke="currentColor"
// //             >
// //               <path
// //                 strokeLinecap="round"
// //                 strokeLinejoin="round"
// //                 strokeWidth={1.5}
// //                 d="M9.75 9.75h.008v.008H9.75V9.75zM14.25 9.75h.008v.008h-.008V9.75zM12 15.75c1.5 0 2.7-.9 3.3-2.1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
// //               />
// //             </svg>
// //             <p className="font-semibold">No data found</p>
// //             <p className="text-xs text-gray-400">
// //               There is no chart data to display right now.
// //             </p>
// //           </div>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };




// // // 3rd  version

// // import React from 'react';
// // import { Bar } from 'react-chartjs-2';
// // import { ChartOptions } from 'chart.js';
// // import {
// //   Chart as ChartJS,
// //   CategoryScale,
// //   LinearScale,
// //   BarElement,
// //   Tooltip,
// //   Legend,
// // } from 'chart.js';

// // ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// // interface BarChartProps {
// //   title?: string;
// //   data: { name: string; value: number; hours?: string }[];

// //   barColor: string;
// //   hoverColor?: string;
// //   labelColor?: string;

// //   totalEmployees?: number;
// //   totalActiveHours?: number;
// //   idlePercentage?: number;
// //   direction?: 'vertical' | 'horizontal';
// //   barThickness?: number | string;
// //   chartWidth: string;
// //   totalPercentage?: number;
// //   barToBarSpace?: number | string;
// // }

// // export const BarChart: React.FC<BarChartProps> = ({
// //   title,
// //   data,
// //   barColor,
// //   hoverColor,
// //   labelColor,
// //   direction = 'vertical',
// //   barThickness = 10,
// //   chartWidth,
// //   barToBarSpace,
// // }) => {
// //   const getDomainName = (url: string): string => {
// //     try {
// //       const hostname = new URL(url).hostname;
// //       return hostname.replace(/^www\./, '').split('.')[0];
// //     } catch {
// //       return url.slice(0, 8);
// //     }
// //   };

// //   const labels = data.map((item) => `${getDomainName(item.name)}..`);
// //   const fullUrls = data.map((item) => item.name);
// //   const values = data.map((item) => item.value);
// //   const hours = data.map((item) => item.hours);

// //   const baseColor = barColor;
// //   const hoverBase = hoverColor || barColor;

// //   // ✅ Use solid colors only
// //   const barColors = values.map(() => baseColor);
// //   const hoverColors = values.map(() => hoverBase);

// //   const isBarPercent =
// //     typeof barThickness === 'string' && barThickness.trim().endsWith('%');
// //   const parsedBarPercentage = isBarPercent
// //     ? parseFloat(barThickness as string) / 100
// //     : undefined;

// //   let categoryPercentage = 0.8;
// //   if (typeof barToBarSpace === 'string' && barToBarSpace.endsWith('%')) {
// //     const percent = parseFloat(barToBarSpace);
// //     categoryPercentage = 1 - percent / 100;
// //   } else if (typeof barToBarSpace === 'number') {
// //     const spacingFactor = Math.min(Math.max(barToBarSpace / 10, 0), 0.9);
// //     categoryPercentage = 1 - spacingFactor;
// //   }

// //   const chartData = {
// //     labels,
// //     datasets: [
// //       {
// //         data: values,
// //         backgroundColor: barColors,
// //         hoverBackgroundColor: hoverColors,
// //         borderRadius: 4,
// //         borderSkipped: false,
// //         borderWidth: 0,
// //         ...(typeof barThickness === 'number'
// //           ? { barThickness, barPercentage: 1 }
// //           : {
// //               barThickness: undefined,
// //               barPercentage: parsedBarPercentage || 0.7,
// //             }),
// //         categoryPercentage,
// //       },
// //     ],
// //   };

// //   const options: ChartOptions<'bar'> = {
// //     indexAxis: direction === 'horizontal' ? 'y' : 'x',
// //     responsive: true,
// //     maintainAspectRatio: false,
// //     plugins: {
// //       tooltip: {
// //         callbacks: {
// //           title: (tooltipItems) => {
// //             const index = tooltipItems[0]?.dataIndex || 0;
// //             return fullUrls[index];
// //           },
// //           label: (context: any) => `${hours[context.dataIndex]}`,

// //         },
// //       },
// //       legend: { display: false },
// //     },
// //     scales: {
// //       x: {
// //         display: true,
// //         grid: { display: false },
// //         ticks: {
// //           callback: (value: any, index: number) => labels[index],
// //           color: labelColor,
// //         },
// //       },
// //       y: {
// //         beginAtZero: true,
// //         suggestedMin: 0,
// //         suggestedMax: 100,
// //         ticks: {
// //           align: 'start',
// //           padding: 10,
// //           color: labelColor,
// //           font: { size: 12 },
// //           stepSize: 20,
// //           callback: (value) => `${value}`,
// //           maxTicksLimit: 8,
// //         },
// //         grid: { display: false },
// //         border: { display: false },
// //       },
// //     },
// //   };

// //   // ✅ Bubble (circle) on hover plugin
// //   const hoverCirclePlugin = {
// //     id: 'hoverCirclePlugin',
// //     afterDraw(chart: any) {
// //       const tooltip = chart.tooltip;
// //       if (!tooltip || !tooltip.opacity || !tooltip.dataPoints?.length) return;

// //       const ctx = chart.ctx;
// //       const point = tooltip.dataPoints[0];

// //       const x = point.element.x;  // x axis theke distance
// //       const y = point.element.y;  // y axis theke distance
// //       const r = 10               // radius

// //       ctx.save();
// //       ctx.beginPath();
// //       ctx.arc(x, y - 1, r, 0, Math.PI * 2);    // ctx.arc(x, y, radius, startAngle, endAngle)
// //       ctx.fillStyle = hoverColor || barColor;
// //       ctx.strokeStyle = '#ffffff';
// //       ctx.lineWidth = 2;
// //       ctx.fill();
// //       ctx.stroke();
// //       ctx.restore();
// //     },
// //   };

// //   return (
// //     <div className="rounded-lg pt-[28px] mb-6 w-full">
// //       <h3 className="text-sm leading-[20px] text-start font-semibold text-[#000000] mb-2">
// //         {title}
// //       </h3>
// //       <div
// //         className="relative flex items-center justify-center h-64 text-xs leading-normal text-[#000]"
// //         style={{ width: chartWidth }}
// //       >
// //         {data?.length > 0 ? (
// //           <Bar data={chartData} options={options} plugins={[hoverCirclePlugin]} />
// //         ) : (
// //           <div className="flex flex-col items-center justify-center text-center px-4 py-6 text-sm text-gray-500">
// //             <svg
// //               xmlns="http://www.w3.org/2000/svg"
// //               className="w-8 h-8 mb-2 text-gray-400"
// //               fill="none"
// //               viewBox="0 0 24 24"
// //               stroke="currentColor"
// //             >
// //               <path
// //                 strokeLinecap="round"
// //                 strokeLinejoin="round"
// //                 strokeWidth={1.5}
// //                 d="M9.75 9.75h.008v.008H9.75V9.75zM14.25 9.75h.008v.008h-.008V9.75zM12 15.75c1.5 0 2.7-.9 3.3-2.1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
// //               />
// //             </svg>
// //             <p className="font-semibold">No data found</p>
// //             <p className="text-xs text-gray-400">
// //               There is no chart data to display right now.
// //             </p>
// //           </div>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };





// // @ts-nocheck
// import type { Chart, ChartOptions, Plugin, TooltipModel } from 'chart.js';
// import {
//   BarElement,
//   CategoryScale,
//   Chart as ChartJS,
//   Legend,
//   LinearScale,
//   Tooltip,
// } from 'chart.js';
// import { formatFractionHourToHM } from 'modules/dashboard/utils/formatMinutesAndHours';
// import React from 'react';
// import { Bar } from 'react-chartjs-2';
// import { useTranslation } from 'react-i18next';


// ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// interface BarChartProps {
//   title?: string;
//   data: { name: string; value: number; hours?: string }[];
//   barColor?: string;
//   hoverColor?: string;
//   labelColor?: string;
//   totalEmployees?: number;
//   totalActiveHours?: number;
//   idlePercentage?: number;
//   totalPercentage?: number;
//   direction?: 'vertical' | 'horizontal';
//   barThickness?: number | string;
//   chartWidth: string;
//   barToBarSpace?: number | string;
//   hoverCircleRadius?: number;
//   chartHeight?: string | number;
//   isYLabel?: boolean;
//   isXLabel?: boolean;
//   isDots?: boolean;
//   barColorArr?: any;
//   hoverName?: string;
//   isHover?: boolean;
// }

// const getOrCreateTooltip = (chart: Chart): HTMLElement => {
//   let tooltipEl = chart.canvas.parentNode?.querySelector<HTMLElement>('div.chartjs-tooltip');

//   if (!tooltipEl) {
//     tooltipEl = document.createElement('div');
//     tooltipEl.className = 'chartjs-tooltip';
//     tooltipEl.style.background = '#ECEFF2';
//     tooltipEl.style.borderRadius = '8px';
//     tooltipEl.style.color = '#333';
//     tooltipEl.style.opacity = '0';
//     tooltipEl.style.pointerEvents = 'none';
//     tooltipEl.style.position = 'absolute';
//     tooltipEl.style.transform = 'translate(-50%, -100%)';
//     tooltipEl.style.transition = 'all 0.15s ease';
//     tooltipEl.style.padding = '10px 12px';
//     // tooltipEl.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
//     // tooltipEl.style.border = '1px solid #e2e8f0';
//     tooltipEl.style.fontFamily = 'sans-serif';
//     tooltipEl.style.minWidth = '200px';
//     tooltipEl.style.display = 'flex';
//     tooltipEl.style.justifyContent = 'center';
//     tooltipEl.innerHTML = `
//       <div class="chartjs-tooltip-content"></div>
//       <div class="chartjs-tooltip-pointer"></div>
//     `;

//     const pointer = tooltipEl.querySelector<HTMLElement>('.chartjs-tooltip-pointer');
//     if (pointer) {
//       pointer.style.position = 'absolute';
//       pointer.style.bottom = '-10px';
//       pointer.style.left = '50%';
//       pointer.style.transform = 'translateX(-50%)';
//       pointer.style.width = '0';
//       pointer.style.height = '0';
//       pointer.style.borderLeft = '10px solid transparent';
//       pointer.style.borderRight = '10px solid transparent';
//       pointer.style.borderTop = '10px solid #ECEFF2';
//     }

//     chart.canvas.parentNode?.appendChild(tooltipEl);
//   }

//   return tooltipEl;
// };


// const externalTooltipHandler = (
//   context: { chart: Chart; tooltip: TooltipModel<'bar'> },
//   fullUrls: string[],
//   hours: (string | undefined)[],
//   circleRadius: number,
//   hoverName?: boolean
// ) => {
//   const { chart, tooltip } = context;
//   const tooltipEl = getOrCreateTooltip(chart);

//   if (tooltip.opacity === 0) {
//     tooltipEl.style.opacity = '0';
//     return;
//   }

//   if (tooltip.body) {
//     // console.log("tooltip: ", tooltip)
//     const dataIndex = tooltip.dataPoints[0].dataIndex;
//     const point = tooltip.dataPoints[0];
//     const name = fullUrls[dataIndex];
//     const a = hours[dataIndex];
//     const value = point.raw
//     // console.log("value: ",value)
//     const timeLabel =
//       hoverName === "Count" ? value : a;

//     const contentEl = tooltipEl.querySelector<HTMLElement>('div.chartjs-tooltip-content');
//     if (contentEl) {
//       const nameText = name.length > 25 ? `${name.substring(0, 25)}...` : name;
//       // contentEl.innerHTML = `
//       //   <div style="font-size: 14px; color: gray;  margin-bottom: 4px; white-space: nowrap;">${nameText}</div>
//       //   <div style="font-size: 14px; color: #334155;">Active Time:<span style="font-weight: 600;"> ${timeLabel}</span></div>
//       // `;

//     let hv = ''; // <-- এখানে fix
// switch (hoverName) {
//   case "Duration":
//     hv += `
//       <div style="font-size: 14px; color: gray; margin-bottom: 4px; white-space: nowrap;">${nameText}</div>
//       <div style="font-size: 14px; color: #334155;">Duration:<span style="font-weight: 600;"> ${timeLabel}</span></div>
//     `;
//     break;
//   case "idle":
//     hv += `
//       <div style="font-size: 14px; color: gray; margin-bottom: 4px; white-space: nowrap;">${nameText}</div>
//       <div style="font-size: 14px; color: #334155;">Idle Time:<span style="font-weight: 600;"> ${timeLabel}</span></div>
//     `;
//     break;
//   case "Count":
//     hv += `
//       <div style="font-size: 14px; color: gray; margin-bottom: 4px; white-space: nowrap;">${nameText}</div>
//       <div style="font-size: 14px; color: #334155;">Count:<span style="font-weight: 600;"> ${timeLabel}</span></div>
//     `;
//     break;
//   case "active":
//   default:
//     hv += `
//       <div style="font-size: 14px; color: gray; margin-bottom: 4px; white-space: nowrap;">${nameText}</div>
//       <div style="font-size: 14px; color: #334155;">Active Time:<span style="font-weight: 600;"> ${timeLabel}</span></div>
//     `;
//     break;
// }

// contentEl.innerHTML = hv;



//     }
//   }

//   const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;
//   const barElement = tooltip.dataPoints[0].element;

//   const pointerAndGap = 15; // Gap between circle and tooltip

//   tooltipEl.style.opacity = '1';
//   tooltipEl.style.left = `${positionX + barElement.x}px`;
//   tooltipEl.style.top = `${positionY + barElement.y - circleRadius - pointerAndGap}px`;
// };


// const createDataLabelPlugin = (hoverName: string | false | undefined): Plugin<"bar"> => ({
//   id: 'dataLabelPlugin',
//   afterDatasetsDraw(chart) {
//     const ctx = chart.ctx;
//     if (!ctx) return;

//     ctx.save();
//     ctx.font = '12px sans-serif';
//     ctx.fillStyle = '#1e293b';
//     ctx.textBaseline = 'middle';

//     chart.data.datasets.forEach((dataset, datasetIndex) => {
//       const meta = chart.getDatasetMeta(datasetIndex);

//       meta.data.forEach((bar: any, index) => {
//         const rawValue = dataset.data[index];
//         const value = Number(rawValue);

//         if (isNaN(value) || value <= 0) return;

//         const formattedValue =
//           hoverName === 'Count' ? value : formatFractionHourToHM(value);

//         // Horizontal bar (indexAxis === 'y')
//         if (chart.config.options?.indexAxis === 'y') {
//           ctx.textAlign = 'left';
//           const x = bar.x + 8; // বারের ভিতর থেকে একটু ডানে
//           const y = bar.y;
//           ctx.fillText(`${formattedValue}`, x, y);
//         }
//         // Vertical bar (default)
//         else {
//           ctx.textAlign = 'center';
//           const x = bar.x;
//           const y = bar.y - 10; // বারের উপরে একটু
//           ctx.fillText(`${formattedValue}`, x, y);
//         }
//       });
//     });

//     ctx.restore();
//   },
// });




// export const BarChart: React.FC<BarChartProps> = ({
//   title,
//   data,
//   barColor,
//   hoverColor,
//   labelColor,
//   direction = 'vertical',
//   barThickness,
//   chartWidth,
//   barToBarSpace,
//   hoverCircleRadius = 5,        // Default radius if none is provided
//   chartHeight = '16rem',
//   isYLabel = true,
//   isXLabel = true,
//   isDots = true,
//   barColorArr,
//   hoverName = false,
//   isHover = true,
// }) => {
//   const labels = data.map((item) => item.name);
//   const fullUrls = data.map((item) => item.name);
//   const values = data.map((item) => item.value);
//   const hours = data.map((item) => item.hours);
//   const { t } = useTranslation()

//   const hoverBase = hoverColor || barColor;

//   let categoryPercentage = 0.8;
//   if (typeof barToBarSpace === 'string' && barToBarSpace.endsWith('%')) {
//     const percent = parseFloat(barToBarSpace);
//     if (!isNaN(percent)) {
//       categoryPercentage = 1 - (Math.max(0, Math.min(100, percent)) / 100);
//     }
//   } else if (typeof barToBarSpace === 'number') {
//     categoryPercentage = 1 - (Math.max(0, Math.min(100, barToBarSpace)) / 100);
//   }

//   const chartData = {
//     // labels: isDots ? labels.map(l => l.slice(0, 8) + '..') : labels,
//     labels: labels,
//     datasets: [
//       {
//         data: values,
//         backgroundColor: barColorArr?.length > 0 ? barColorArr : barColor,
//         hoverBackgroundColor: hoverBase,
//         borderRadius: 4,
//         borderSkipped: false,
//         borderWidth: 0,
//         barThickness: typeof barThickness === 'number' ? barThickness : undefined,
//         categoryPercentage,
//       },
//     ],
//   };

//   const options: ChartOptions<'bar'> = {
//     indexAxis: direction === 'horizontal' ? 'y' : 'x',
//     responsive: true,
//     maintainAspectRatio: false,
//     // plugins: {
//     //   tooltip: {
//     //     enabled: false,
//     //     external: (context) => externalTooltipHandler(context, fullUrls, hours, hoverCircleRadius, hoverName),
//     //   },
//     //   legend: { display: false },
//     // },

//     plugins: {
//       tooltip: isHover
//         ? {
//           enabled: false,
//           external: (context) => externalTooltipHandler(context, fullUrls, hours, hoverCircleRadius, hoverName),
//         }
//         : {
//           enabled: false,
//         },
//       legend: { display: false },
//     },

//     scales: {
//       x: !isXLabel ? {
//         display: false, // ✅ y label পুরো off
//       } : { display: true, grid: { display: false }, ticks: { color: labelColor } },
//       y: !isYLabel ? {

//         display: false, // ✅ y label পুরো off
//       } :
//         { display: true, offset: true, beginAtZero: true, grid: { display: true, drawTicks: false, color: '#F1F5F9' }, border: { display: false }, ticks: { padding: 10, paddingLeft: 30, color: labelColor } },

//     },
//   };

//   const hoverCirclePlugin: Plugin<"bar"> = {
//     id: 'hoverCirclePlugin',
//     afterDraw(chart, args, options) {
//       const { tooltip } = chart;
//       if (!tooltip || !tooltip.opacity || !tooltip.dataPoints?.length) return;

//       const ctx = chart.ctx;
//       const point = tooltip.dataPoints[0];
//       const { x, y } = point.element;
//       const r = hoverCircleRadius;

//       ctx.save();
//       ctx.beginPath();
//       ctx.arc(x, y, r, 0, Math.PI * 2);
//       ctx.fillStyle = hoverBase;
//       ctx.strokeStyle = '#ffffff';
//       ctx.lineWidth = 3;
//       ctx.fill();
//       ctx.stroke();
//       ctx.restore();
//     },
//   };

//   return (
//     <div className="rounded-lg  mb-1 w-full">
//       <h3 className="text-sm leading-[20px] text-start font-semibold text-[#000000] mb-2">
//         {title}
//       </h3>
//       <div className="  flex items-center justify-center text-xs leading-normal" style={{ width: chartWidth, height: chartHeight }} >
//         {data?.length > 0 ? (
//           <Bar
//             data={chartData}
//             options={options}
//             plugins={[
//               hoverCirclePlugin,
//               createDataLabelPlugin(hoverName)
//             ]}
//           />
//         ) : (
//           <div className="flex flex-col items-center gap-2 justify-center text-center px-4 py-6 text-sm text-gray-500">
//             {/* ... No data SVG ... */}
//             <p className="font-semibold">{t('dashboard:barChart:noData')}</p>
//             <p className="text-xs text-gray-400">{t('dashboard:barChart:noLog')}</p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };



// Responsive version without scroll x 

// @ts-nocheck
import type { Chart, ChartOptions, Plugin, TooltipModel } from 'chart.js';
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip,
} from 'chart.js';
import { formatFractionHourToHM } from 'modules/dashboard/utils/formatMinutesAndHours';
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

interface BarChartProps {
  title?: string;
  data: { name: string; value: number; hours?: string }[];
  barColor?: string;
  hoverColor?: string;
  labelColor?: string;
  totalEmployees?: number;
  totalActiveHours?: number;
  idlePercentage?: number;
  totalPercentage?: number;
  direction?: 'vertical' | 'horizontal';
  barThickness?: number | string;
  chartWidth: string;
  barToBarSpace?: number | string;
  hoverCircleRadius?: number;
  chartHeight?: string | number;
  isYLabel?: boolean;
  isXLabel?: boolean;
  isDots?: boolean;
  barColorArr?: any;
  hoverName?: string;
  isHover?: boolean;
}

const getOrCreateTooltip = (chart: Chart): HTMLElement => {
  // Look for tooltip in the body or parent to avoid overflow:hidden issues
  let tooltipEl = document.querySelector<HTMLElement>('.chartjs-tooltip-global');

  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.className = 'chartjs-tooltip-global';
    tooltipEl.style.background = '#ECEFF2';
    tooltipEl.style.borderRadius = '8px';
    tooltipEl.style.color = '#333';
    tooltipEl.style.opacity = '0';
    tooltipEl.style.pointerEvents = 'none';
    tooltipEl.style.position = 'fixed'; // Use fixed to escape any overflow:hidden
    tooltipEl.style.zIndex = '9999';
    tooltipEl.style.transform = 'translate(-50%, -100%)';
    tooltipEl.style.transition = 'opacity 0.15s ease';
    tooltipEl.style.padding = '10px 12px';
    tooltipEl.style.boxShadow = '0 4px 6px -1px rgb(0 0 0 / 0.1)';
    tooltipEl.style.fontFamily = 'sans-serif';
    tooltipEl.style.minWidth = '150px';
    tooltipEl.innerHTML = `
      <div class="tooltip-content"></div>
      <div class="tooltip-arrow" style="position:absolute; bottom:-8px; left:50%; transform:translateX(-50%); width:0; height:0; border-left:8px solid transparent; border-right:8px solid transparent; border-top:8px solid #ECEFF2;"></div>
    `;
    document.body.appendChild(tooltipEl);
  }

  return tooltipEl;
};

const externalTooltipHandler = (
  context: { chart: Chart; tooltip: TooltipModel<'bar'> },
  fullUrls: string[],
  hours: (string | undefined)[],
  circleRadius: number,
  hoverNameProp?: string
) => {
  const { chart, tooltip } = context;
  const tooltipEl = getOrCreateTooltip(chart);

  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = '0';
    return;
  }

  if (tooltip.body) {
    const dataIndex = tooltip.dataPoints[0].dataIndex;
    const point = tooltip.dataPoints[0];
    const fullName = fullUrls[dataIndex]; // Get the full name from the original data
    const hourLabel = hours[dataIndex];
    const value = point.raw;

    const contentEl = tooltipEl.querySelector<HTMLElement>('.tooltip-content');
    if (contentEl) {
      const timeLabel = hoverNameProp === "Count" ? value : hourLabel;
      
      let labelTitle = "Active Time";
      if(hoverNameProp === "Duration") labelTitle = "Duration";
      else if(hoverNameProp === "idle") labelTitle = "Idle Time";
      else if(hoverNameProp === "Count") labelTitle = "Count";

      contentEl.innerHTML = `
        <div style="font-size: 13px; color: #64748b; margin-bottom: 2px; font-weight: 500;">${fullName}</div>
        <div style="font-size: 13px; color: #1e293b;">${labelTitle}: <span style="font-weight: 700;">${timeLabel}</span></div>
      `;
    }
  }

  const { left, top } = chart.canvas.getBoundingClientRect();

  tooltipEl.style.opacity = '1';
  tooltipEl.style.left = `${left + window.pageXOffset + tooltip.caretX}px`;
  tooltipEl.style.top = `${top + window.pageYOffset + tooltip.caretY - circleRadius - 12}px`;
};

const createDataLabelPlugin = (hoverName: string | false | undefined): Plugin<"bar"> => ({
  id: 'dataLabelPlugin',
  afterDatasetsDraw(chart) {
    const ctx = chart.ctx;
    ctx.save();
    ctx.font = '11px sans-serif';
    ctx.fillStyle = '#1e293b';
    ctx.textBaseline = 'middle';

    chart.data.datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex);
      meta.data.forEach((bar: any, index) => {
        const value = Number(dataset.data[index]);
        if (isNaN(value) || value <= 0) return;
        const formattedValue = hoverName === 'Count' ? value : formatFractionHourToHM(value);
        
        if (chart.config.options?.indexAxis === 'y') {
          ctx.textAlign = 'left';
          ctx.fillText(`${formattedValue}`, bar.x + 8, bar.y);
        } else {
          ctx.textAlign = 'center';
          ctx.fillText(`${formattedValue}`, bar.x, bar.y - 15);
        }
      });
    });
    ctx.restore();
  },
});

export const BarChart: React.FC<BarChartProps> = ({
  title,
  data,
  barColor,
  hoverColor,
  labelColor,
  direction = 'vertical',
  barThickness,
  chartWidth = '100%',
  barToBarSpace,
  hoverCircleRadius = 5,
  chartHeight = '18rem',
  isYLabel = true,
  isXLabel = true,
  barColorArr,
  hoverName = false,
  isHover = true,
}) => {
  const { t } = useTranslation();
  const fullUrls = data.map((item) => item.name);
  const hours = data.map((item) => item.hours);
  const hoverBase = hoverColor || barColor;
  const chartData = {
    labels: data.map((item) => item.name),
    datasets: [
      {
        data: data.map((item) => item.value),
        backgroundColor: barColorArr?.length > 0 ? barColorArr : barColor,
        hoverBackgroundColor: hoverBase,
        borderRadius: 4,
        borderSkipped: false,
        borderWidth: 0,
        barThickness: typeof barThickness === 'number' ? barThickness : undefined,
        categoryPercentage: 0.8,
      },
    ],
  };

  const options: ChartOptions<'bar'> = {
    indexAxis: direction === 'horizontal' ? 'y' : 'x',
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: { top: 30, right: 20, left: 10, bottom: 10 }
    },
    plugins: {
      tooltip: isHover ? {
        enabled: false,
        external: (context) => externalTooltipHandler(context, fullUrls, hours, hoverCircleRadius, hoverName),
      } : { enabled: false },
      legend: { display: false },
    },
    scales: {
      x: !isXLabel ? { display: false } : { 
        display: true, 
        grid: { display: false }, 
        ticks: { 
          color: labelColor,
          font: { size: 11 },
          maxRotation: 45,
          autoSkip: true,
          callback: function(value, index) {
            const label = this.getLabelForValue(value);
            return label.length > 12 ? label.substring(0, 10) + '..' : label;
          }
        } 
      },
      y: !isYLabel ? { display: false } : { 
        display: true, 
        beginAtZero: true, 
        grid: { drawTicks: false, color: '#F1F5F9' }, 
        border: { display: false },
        ticks: { color: labelColor, font: { size: 10 } }
      },
    },
  };

  const hoverCirclePlugin: Plugin<"bar"> = {
    id: 'hoverCirclePlugin',
    afterDraw(chart) {
      const { tooltip } = chart;
      if (!tooltip || !tooltip.opacity || !tooltip.dataPoints?.length) return;
      const ctx = chart.ctx;
      const point = tooltip.dataPoints[0];
      const { x, y } = point.element;
      ctx.save();
      ctx.beginPath();
      ctx.arc(x, y, hoverCircleRadius, 0, Math.PI * 2);
      ctx.fillStyle = hoverBase;
      ctx.strokeStyle = '#ffffff';
      ctx.lineWidth = 3;
      ctx.fill();
      ctx.stroke();
      ctx.restore();
    },
  };

  return (
    <div className="w-full mb-1">
      {title && <h3 className="text-sm font-semibold text-[#000] mb-2">{title}</h3>}
      <div className="relative" style={{ width: chartWidth, height: chartHeight }}>
        {data?.length > 0 ? (
          <Bar data={chartData} options={options} plugins={[hoverCirclePlugin, createDataLabelPlugin(hoverName)]} />
        ) : (
          <div className="flex flex-col items-center justify-center h-full text-gray-500">
            <p className="font-semibold">{t('dashboard:barChart:noData')}</p>
          </div>
        )}
      </div>
    </div>
  );
};
